<div class="rest_dra">
  <div class="frm_date_dra">
    <div
      class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start"
    >
      <div class="title d-flex align-items-center">
        <button mat-icon-button (click)="navigate()" class="me-3">
          <mat-icon class="material-icons-round">arrow_back</mat-icon>
        </button>
        <div>
          <h1>{{ "invoice_report.title" | translate }}</h1>
          <h2 class="m-0" *ngIf="pageSubTitle">{{ pageSubTitle }}</h2>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>

      <button *ngIf="showButton" mat-button>{{ showButton }}</button>
    </div>
    <div class="row" style="padding-left: 15px">
      <div class="col-sm-8">
        <div class="date-range-form">
          <div class="nw_all">
            <mat-form-field
              appearance="outline"
              (click)="fromDatePicker.open()"
            >
              <mat-label>From Date</mat-label>
              <input
                matInput
                [matDatepicker]="fromDatePicker"
                name="fromDate"
                [(ngModel)]="fromDate"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="fromDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #fromDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="nw_all">
            <mat-form-field appearance="outline" (click)="toDatePicker.open()">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [matDatepicker]="toDatePicker"
                name="toDate"
                [(ngModel)]="toDate"
                [max]="today"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="toDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #toDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="search_pag">
            <button
              (click)="search()"
              mat-flat-button
              color="primary"
              type="submit"
            >
              {{ "invoice_report.search" | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-4" style="display: flex; justify-content: end; gap: 15px;align-items: baseline;">
        <div class="create_btn_sd">
          <button
            mat-flat-button
            color="primary"
            (click)="createInvoice()"
            *ngIf="isAccessForEmployeeInvoice"
          >
            <mat-icon>add</mat-icon>
            Invoice
          </button>
        </div>
        <div class="" *ngIf="isOwner">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu23"
            aria-label="Example icon-button with a menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu23="matMenu">
            <button mat-menu-item (click)="openaadvancepaymentsetup()">
              <mat-icon>settings</mat-icon>
              <span>Advance payment</span>
            </button>
          </mat-menu>
        </div>
      </div>

    </div>
  </div>
</div>

<mat-card *ngIf="visible && invoiceReportData.length > 0">
  <mat-card-header class="justify-content-between align-items-center mb-3">
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumns"
      [dataSource]="invoiceReportData"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [showPagination]="true"
      [itemsPerPage]="25"
      [rowClickHandler]="rowClickHandler"
    >
    </sm-data-table-for-appointments>
  </div>
</mat-card>
<!-- <sm-line-chart></sm-line-chart> -->

<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item (click)="openInvoice(rowvalue)">
    <mat-icon class="material-icons-outlined">badge</mat-icon>
    <span>{{ "invoice_report.op1" | translate }}</span>
  </button>
</ng-template>

<!-- Placeholder section start -->

<div
  class="invoices_placeholder_section"
  *ngIf="!loader && visible && invoiceReportData.length == 0"
>
  <div class="placeholder_started">
    <div class="row">
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/printing-invoices.png" />
              </div>
              <mat-card-title>No invoice/bill to show </mat-card-title>
              <mat-card-content
                >All the invoices will appear here between the selected date
                range. Either no invoice created yet or check the dates.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  *ngIf="isAccessForEmployeeInvoice"
                  mat-stroked-button
                  color="primary"
                  style="width: 155px; font-size: 15px"
                  (click)="createInvoice()"
                >
                  <mat-icon>add</mat-icon>
                  Invoice
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="/assets/images/new-booking.png" />
              </div>
              <mat-card-title>How to generate invoice?</mat-card-title>
              <mat-card-content
                >Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                on producing a new invoice against a business. You can check
                this video as well.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in producing new invoice or in any issue
                while getting the list, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Placeholder section end -->
